import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getStudioSocialLink'
})
export class StudioSocialLinkArrayPipe implements PipeTransform {

  transform(socialLinksArray:any, formArray: Array<any>): Array<any> {
    let latestLinkArray: Array<any> = JSON.parse(JSON.stringify(socialLinksArray));
    formArray.map((item: any) =>  {
      let foundData = latestLinkArray.findIndex((socialObj: any) => socialObj.id === item.type);
      if (foundData > -1) {
        latestLinkArray.splice(foundData, 1);
      }
    })
    return latestLinkArray;
  }

}
